// Page: find-solar-popup  (dashboard "find community solar" popup + returning-user
// deal creation)
//
// Ported from the inline <script> in
//   Enrollment_modules/dashboard/find-solar-popup.module/module.html (lines 46–1183).
//
// MECHANICAL / FAITHFUL PORT — runtime behaviour is preserved. Deliberate changes
// (same family as the pilot, see docs/handoff/global-js-deep-refactor-notes.md):
//   1. Selectors that were scoped to this module's own wrapper
//      (`.findSolarPopup #child`, the bare `#gsicode`, `.lfcsiya-main.findSolarPopup
//      .crossButton img`, and `.lfcsiya-main.findSolarPopup` itself) are now scoped
//      to `root`. The original had NO live `#Page_0_*_widget` toggles — every such
//      reference in this module was already commented out.
//   2. `_hcms/api/*` fetches are ROOT-RELATIVE (apiUrl) and same-origin redirects
//      (`enrollment.nautilussolar.com/il-usage`, `/my-info?mltenlmt`, `/dashboard`)
//      are root-relative, instead of hardcoding https://enrollment.nautilussolar.com.
//      The cross-subdomain redirect to https://enroll.nautilussolar.com/ is a
//      DIFFERENT origin and stays absolute.
//   3. HubDB reads go through core/hubdb (`hubdbRowsUrl`) using window.__ENV__ table
//      ids + the fixed dataPortalId (was inline `${window.__ENV__.hubdb.X}` literals).
//   4. localStorage goes through core/storage (rawGet/rawSet/rawRemove — the many
//      broker_/Farm*/log* keys aren't in the typed StorageKey union yet).
//   5. Implicit globals in the original (bare assigns, no `var`: repid, referralUrl)
//      plus the locally-shadowed first_visited_url / dealOwner are declared at the
//      top of init so strict-mode ESM doesn't throw ReferenceError.
//   6. Inline onclick/oninput handlers (findSolar / validateNumericInput) are bound
//      in init instead of via HTML attributes.
//
// External loader globals `enterZipOpenLoader()` / `enterZipcloseLoader()` are
// defined by a SIBLING dashboard widget, not by this module and not by the theme
// TS. They are NOT declared in global.d.ts, so they are called via `(window as any)`
// (they resolve to the page globals at runtime exactly as the inline script did).
//
// Dynamic ES5 patterns (HubDB row shapes, vars reassigned across types) are typed
// `any` to keep the port mechanical. `clearDatabase` is DEFINED here (it is the
// inline-script source of the global that sibling modules call); the local
// definition shadows the ambient global.d.ts declaration.

import { apiUrl } from "../../core/api"
import { hubdbRowsUrl } from "../../core/hubdb"
import * as storage from "../../core/storage"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/self-serve/find-solar-popup.ts","init",[root,_config],["root","_config"]);
  // implicit globals in the original (bare assigns / locally-shadowed globals) —
  // declared here so strict-mode ESM doesn't throw.
  let repid: any
  let referralUrl: any
  let dealOwner: any = 0
  let responseFromAPI: any = ""

  const crossButtonImg = root.querySelector(".crossButton img") as HTMLImageElement | null
  if (crossButtonImg) {
    crossButtonImg.onclick = () => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[],[]);
      hidePopup()
    }
  }

  function hidePopup() {
__ea_trace("modules/self-serve/find-solar-popup.ts","hidePopup",[],[]);
    root.style.display = "none"
  }

  /* validate input to just type number value */
  function validateNumericInput(input: HTMLInputElement) {
__ea_trace("modules/self-serve/find-solar-popup.ts","validateNumericInput",[input],["input"]);
    // Remove non-numeric characters using a regular expression
    input.value = input.value.replace(/[^0-9]/g, "")
  }
  /* validate input to just type number value */
  async function findSolar() {
__ea_trace("modules/self-serve/find-solar-popup.ts","findSolar",[],[]);
    ;(window as any).enterZipOpenLoader()
    const prevDealAttcode = storage.rawGet("gotAttCode")
    void prevDealAttcode
    let localattcode: any = storage.rawGet("attcode")
    const attRepId = storage.rawGet("repid")
    if (localattcode == null) {
      let attcode = (root.querySelector("#gsicode") as HTMLInputElement).value.trim()
      if ((!attcode as any) === "") {
        attcode = attcode.toUpperCase()
        // if attribution code field is not blank
        //old ERattribution table id 7940140
        // live ER attribution table id 15223651
        const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
          attribution_code: attcode,
          default_broker_contact: 1,
        })
        fetch(hubDBEndpoint, {
          method: "GET",
        })
          .then((response) => response.json())
          .then((data) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[data],["data"]);
            const rows = data.objects
            if (rows.length >= 1) {
              let isFirstIteration = true
              rows.forEach((element: any) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[element],["element"]);
                if (isFirstIteration) {
                  isFirstIteration = false
                  repid = element.values["10"]
                  referralUrl = element.values["5"]
                  dealOwner = element.values["11"]
                  storage.rawSet("attcode", attcode)
                  storage.rawSet("repid", repid)
                  storage.rawSet("referralUrl", referralUrl)
                  const brokerRepPhoneNo = element.values["6"]
                  const brokerRepEmail = element.values["7"]
                  const brokerRepTitle = element.values["9"]
                  const brokerRepName = element.values["4"]
                  const brokerCompany = element.values["2"]
                  if (element.values["8"] !== undefined) {
                    const brokerRepImage = element.values["8"].url
                    storage.rawSet("brokerRepImage", brokerRepImage)
                  }
                  if (element.values["13"] !== undefined) {
                    const brokerMeetingUrl = element.values["13"].url
                    storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                  }
                  storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                  storage.rawSet("brokerRepEmail", brokerRepEmail)
                  storage.rawSet("brokerRepTitle", brokerRepTitle)
                  if (brokerRepName !== undefined) {
                    storage.rawSet("brokerRepName", brokerRepName)
                  }
                  storage.rawSet("brokerCompany", brokerCompany)
                  storage.rawSet("sidebarBrokerDisplay", "Yes")
                }
              })
            } else {
              storage.rawSet("sidebarBrokerDisplay", "No")
            }
          })
      } else {
        storage.rawSet("sidebarBrokerDisplay", "No")
      }
    } else {
      localattcode = localattcode.toUpperCase()
      const hubDBEndpoint = hubdbRowsUrl("brokerAttribution", {
        attribution_code: localattcode,
      })
      fetch(hubDBEndpoint, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[data],["data"]);
          const rows = data.objects
          if (rows.length >= 1) {
            for (let i = 0; i < rows.length; i++) {
              const element = rows[i]
              if (element.values["5"].includes(attRepId) && element.values["5"].includes(localattcode)) {
                dealOwner = element.values["11"]
                const brokerRepPhoneNo = element.values["6"]
                const brokerRepEmail = element.values["7"]
                const brokerRepTitle = element.values["9"]
                const brokerRepName = element.values["4"]
                const brokerCompany = element.values["2"]
                if (element.values["8"] !== undefined) {
                  const brokerRepImage = element.values["8"].url
                  storage.rawSet("brokerRepImage", brokerRepImage)
                }
                if (element.values["13"] !== undefined) {
                  const brokerMeetingUrl = element.values["13"].url
                  storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                }
                storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                storage.rawSet("brokerRepEmail", brokerRepEmail)
                storage.rawSet("brokerRepTitle", brokerRepTitle)
                if (brokerRepName !== undefined) {
                  storage.rawSet("brokerRepName", brokerRepName)
                }
                storage.rawSet("brokerCompany", brokerCompany)
                storage.rawSet("sidebarBrokerDisplay", "Yes")
                break
              } else {
                if (i === rows.length - 1) {
                  // Code to execute on the last iteration
                  for (let k = 0; k < rows.length; k++) {
                    const elementt = rows[k]
                    if (elementt.values["5"].includes(localattcode)) {
                      if (elementt.values["12"] === 1) {
                        dealOwner = elementt.values["11"]
                        repid = elementt.values["10"]
                        const brokerRepPhoneNo = elementt.values["6"]
                        const brokerRepEmail = elementt.values["7"]
                        const brokerRepTitle = elementt.values["9"]
                        const brokerRepName = elementt.values["4"]
                        const brokerCompany = elementt.values["2"]
                        if (elementt.values["8"] !== undefined) {
                          const brokerRepImage = elementt.values["8"].url
                          storage.rawSet("brokerRepImage", brokerRepImage)
                        }
                        if (elementt.values["13"] !== undefined) {
                          const brokerMeetingUrl = elementt.values["13"].url
                          storage.rawSet("brokerMeetingUrl", brokerMeetingUrl)
                        }
                        storage.rawSet("brokerRepPhoneNo", brokerRepPhoneNo)
                        storage.rawSet("brokerRepEmail", brokerRepEmail)
                        storage.rawSet("brokerRepTitle", brokerRepTitle)
                        if (brokerRepName !== undefined) {
                          storage.rawSet("brokerRepName", brokerRepName)
                        }
                        storage.rawSet("brokerCompany", brokerCompany)
                        storage.rawSet("sidebarBrokerDisplay", "Yes")
                        storage.rawSet("repid", repid)
                        break
                      } else {
                        if (k === rows.length - 1) {
                          storage.rawRemove("attcode")
                          storage.rawRemove("repid")
                          storage.rawSet("sidebarBrokerDisplay", "No")
                        }
                      }
                    }
                  }
                }
              }
            }
          } else {
            storage.rawRemove("attcode")
            storage.rawRemove("repid")
            storage.rawSet("sidebarBrokerDisplay", "No")
          }
        })
    }

    /* list items getting removed on page load - multiple utility name/zip code */
    const utilitynameCardss = root.querySelector("#retailUtilities-main") as HTMLElement // ul li div
    utilitynameCardss.style.display = "none" // display none ul div because on page load
    const listt = root.querySelector("#retailUtilities") as HTMLElement // Get the ul element
    listt.innerHTML = "" // Remove all li elements inside the ul
    /* list items getting removed on page load - multiple utility name/zip code */

    // hoisted (was var) so the nested recursive checkZipCodeInHubDB closes over them
    const limit = 1000
    let offset = 0
    let allRows: any[] = []
    let zipcount = 0
    const allFarmRows: any[] = []
    void allFarmRows

    const enteredZip = (root.querySelector("#zipCode") as HTMLInputElement).value.trim() // Get the entered zip code
    if (enteredZip !== "") {
      // Check if the zip code is not empty
      ;(root.querySelector("#resultMessage") as HTMLElement).style.display = "none"
      checkZipCodeInHubDB(enteredZip) // Call a function to check the zip code in HubDB
    } else {
      // Clear result message if the zip code is empty
      ;(root.querySelector("#resultMessage") as HTMLElement).style.display = "block"
      ;(root.querySelector("#resultMessage") as HTMLElement).innerText = "Please enter a zip code."
    }

    // Function to check the zip code in HubDB
    function checkZipCodeInHubDB(zipCode: string): any {
__ea_trace("modules/self-serve/find-solar-popup.ts","checkZipCodeInHubDB",[zipCode],["zipCode"]);
      //live site utility zip table id 15223653

      const hubDBEndpoint = hubdbRowsUrl("communitySolar", {
        limit: limit,
        offset: offset,
      })
      fetch(hubDBEndpoint, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[data],["data"]);
          const matchingRows = data.objects.filter((row: any) => row.values[1] === zipCode)
          const rows = data.objects
          if (matchingRows.length >= 1) {
            allRows = allRows.concat(matchingRows)
          }
          if (rows.length === limit) {
            // There might be more rows, fetch the next page
            offset += limit
            return checkZipCodeInHubDB(enteredZip)
          }
          if (allRows.length >= 1) {
            for (let m = 0; m < allRows.length; m++) {
              const currentObject = allRows[m]
              const zipColId = 1 //zip code column id
              const RetailUtiColId = 4 // Retail utility column id

              const zip = currentObject.values[zipColId]
              const utilityDisplayName = currentObject.values[RetailUtiColId]
              const utility_id = currentObject.values[3] // utility id column id
              const county = currentObject.values[5]
              const newItem = document.createElement("li") // create li
              newItem.id = utility_id // create id for each li
              if (utilityDisplayName !== undefined) {
                newItem.textContent = utilityDisplayName
              } else {
                newItem.textContent = utility_id
              }
              const utilitynameCards = root.querySelector("#retailUtilities-main") as HTMLElement // ul li div
              const list = root.querySelector("#retailUtilities") as HTMLElement // ul
              list.appendChild(newItem) // append items to ul
              zipcount = ++zipcount // pre increament for set condition if multiple zip code
              if (zipcount > 1) {

                utilitynameCards.style.display = "block" // display block ul div because there are multiple zip code
                /* ------- Add active class click on utility name li ---------- */
                ;(root.querySelector("#retailUtilities") as HTMLElement).addEventListener("click", (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
                  if ((event.target as HTMLElement).tagName === "LI") {
                    ;(window as any).enterZipOpenLoader()
                    root.querySelectorAll("#retailUtilities li").forEach((item) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[item],["item"]);
                      item.classList.remove("active")
                    })
                    ;(event.target as HTMLElement).classList.add("active")
                    const activeLiId = root.querySelector("#retailUtilities li.active") as HTMLElement
                    const activeLiIdd = activeLiId.id
                    const UtilityDisplayNameForSignUp = activeLiId.textContent as string
                    storage.rawSet("utility_Name", UtilityDisplayNameForSignUp)
                    storage.rawSet("utility_id", activeLiIdd)
                    storage.rawSet("zip_code", zipCode)
                    storage.rawSet("county", county)
                    checkUtilityIdInFarmTable(activeLiIdd)
                  }
                })
                /* ------- Add active class click on utility name li ---------- */
                ;(window as any).enterZipcloseLoader()
              } else {
                if (m === allRows.length - 1) {
                  // let utilityId = localStorage.getItem('utility_id');
                  storage.rawSet("utility_Name", utilityDisplayName)
                  storage.rawSet("utility_id", utility_id)
                  storage.rawSet("zip_code", zipCode)
                  storage.rawSet("county", county)
                  checkUtilityIdInFarmTable(utility_id)
                }
              }
            }
          } else {
            ;(window as any).enterZipcloseLoader()
            alert("did not found zip code")
            return
          }
          return allRows
        })
        .catch((error) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[error],["error"]);
        })
    }
  }

  const first_visited_url: any = storage.rawGet("first_visited_url")

  // Index Db Part
  const request = indexedDB.open("myDatabase", 1)
  let db: IDBDatabase
  request.onerror = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    console.log(`Database error: ${(event.target as any).errorCode}`)
  }
  request.onsuccess = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    db = (event.target as IDBRequest).result
  }
  request.onupgradeneeded = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    const db = (event.target as IDBRequest).result as IDBDatabase

    // Create an object store (similar to a table in relational databases)
    const objectStore = db.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }
  function clearDatabase() {
__ea_trace("modules/self-serve/find-solar-popup.ts","clearDatabase",[],[]);
    const transaction = db.transaction(Array.from(db.objectStoreNames), "readwrite")

    transaction.oncomplete = () => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[],[]);
    }

    transaction.onerror = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    }

    Array.from(db.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[storeName],["storeName"]);
      const objectStore = transaction.objectStore(storeName)
      objectStore.clear()
    })
  }

  /* lmi database removed */
  //index DB
  const requestlmi = indexedDB.open("LmiDatabase", 1)
  let dblmi: IDBDatabase

  requestlmi.onerror = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
  }
  requestlmi.onsuccess = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    dblmi = (event.target as IDBRequest).result
    clearDatabaselmi()
  }
  requestlmi.onupgradeneeded = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    const dblmi = (event.target as IDBRequest).result as IDBDatabase

    // Create an object store (similar to a table in relational databases)
    const objectStore = dblmi.createObjectStore("files", { autoIncrement: true })

    // Optionally, you can create indexes for efficient querying
    objectStore.createIndex("name", "name", { unique: false })
  }
  function clearDatabaselmi() {
__ea_trace("modules/self-serve/find-solar-popup.ts","clearDatabaselmi",[],[]);
    const transactionlmi = dblmi.transaction(Array.from(dblmi.objectStoreNames), "readwrite")

    transactionlmi.oncomplete = () => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[],[]);
    }

    transactionlmi.onerror = (event) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[event],["event"]);
    }

    Array.from(dblmi.objectStoreNames).forEach((storeName) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[storeName],["storeName"]);
      const objectStorelmi = transactionlmi.objectStore(storeName)
      objectStorelmi.clear()
    })
  }
  /* create deal record */
  async function createDealRecord(): Promise<void> {
__ea_trace("modules/self-serve/find-solar-popup.ts","createDealRecord",[],[]);
    let emaill: any = storage.rawGet("logEmail")
    emaill = emaill.toLowerCase()
    const cntId = `New Enrollment - ${storage.rawGet("contactId")}`
    const contactId = storage.rawGet("contactId")
    let FarmStateAbbreviation: any = storage.rawGet("FarmStateAbbreviation")
    let dealStage = "157471033"
    if (FarmStateAbbreviation === "IL") {
      dealStage = "984278683"
    }
    if (FarmStateAbbreviation === "undefined") {
      FarmStateAbbreviation = ""
    }
    const zip_code = storage.rawGet("zip_code")
    const utId = storage.rawGet("utility_id")
    const utName = storage.rawGet("utility_Name")
    let catchdata: any = ""
    try {
      const dataa = {
        properties: {
          deal_email_test: emaill,
          dealname: cntId,
          dealstage: dealStage,
          service_state_abbreviation: FarmStateAbbreviation,
          postal_code: zip_code,
          utility_id: utId,
          utility_name: utName,
        },
      }
      const response = await fetch(apiUrl("AddDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataa),
      })
      catchdata = dataa
      const dealResult = await response.json()
      responseFromAPI = JSON.stringify(dealResult)
      const dealId = dealResult.id
      if (response.status === 200) {
        storage.rawSet("dealId", dealId)
        await dealAssociateWithContact(contactId, dealId)
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function getDataFromContactRecordAndSaveLocal(dealId: any): Promise<void> {
__ea_trace("modules/self-serve/find-solar-popup.ts","getDataFromContactRecordAndSaveLocal",[dealId],["dealId"]);
    void dealId
    let email: any = storage.rawGet("logEmail")
    email = email.toLowerCase()
    //         localStorage.setItem('dealId', email);
    let catchdata: any = ""
    try {
      const data = {
        email: email,
      }
      const response = await fetch(apiUrl("GetContactRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)
      if (dataa.message === "No User Found") {
        //                 enterZipcloseLoader();
      } else if (dataa.message === "User Found") {
        //                 var log_zipCode = dataa['userValue']['properties']['service_postal_code'];
        //                 var log_utilityID = dataa['userValue']['properties']['enrollment_utility_id'];
        const log_referral_url = dataa.userValue.properties.referral_url
        const log_attribution_code = dataa.userValue.properties.attribution_code
        void log_referral_url
        void log_attribution_code
        const recordId = dataa.userValue.properties.hs_object_id
        const firstName = dataa.userValue.properties.firstname
        const lastName = dataa.userValue.properties.lastname
        const onboardToken = dataa.userValue.properties.bayou_onboarding_token
        const home_phone = dataa.userValue.properties.phone
        const cell_phone = dataa.userValue.properties.mobilephone
        //                     var address1 = dataa["userValue"]["properties"]["service_street_addresss"];
        //                     var address2 = dataa["userValue"]["properties"]["service_street_address_2"];
        //                     var city = dataa["userValue"]["properties"]["service_city"];
        //                     var state = dataa["userValue"]["properties"]["state___region"];
        const dateOfBirth = dataa.userValue.properties.date_of_birth
        const bayouContactId = dataa.userValue.properties.bayou_contact_id
        const is_enrolled_for_bayou = dataa.userValue.properties.is_enrolled_for_bayou
        storage.rawSet("RecordId", recordId)
        storage.rawSet("LoggedName", `${firstName} ${lastName}`)
        storage.rawSet("FirstName", firstName)
        storage.rawSet("LastName", lastName)
        storage.rawSet("CompanyName", `${firstName}&${lastName}`)
        storage.rawSet("DateOfBirth", dateOfBirth)
        storage.rawSet("onboarding_token", onboardToken)
        storage.rawSet("bayou_contact_id", bayouContactId)
        storage.rawSet("BayouContactId", bayouContactId)
        storage.rawSet("CellPhone", cell_phone)
        storage.rawSet("HomePhone", home_phone)
        if (is_enrolled_for_bayou === "yes") {
          storage.rawSet("is_enrolled_for_bayou", "yes")
        }
        //                     localStorage.setItem("Address",address1 + ", " + address2 + ", " + city + ", " + state);
        //                 var checkUID = localStorage.getItem('utility_id');
        //                 var checkZC = localStorage.getItem('zip_code');
        //                 var checkUN = localStorage.getItem('utility_Name');
        //                 if (log_attribution_code != null && log_attribution_code != "") {
        //                     sampleOriginType = "Invite";
        //                     sampleSessiontype = "Consumer Completing";
        //                 }
        //                 else {
        //                     sampleOriginType = "Direct";
        //                     sampleSessiontype = "Consumer Only";
        //                 }
        //                 if (log_utilityID != null) {
        //                     localStorage.setItem('utility_id', log_utilityID);
        //                 }
        //                 if (log_zipCode != null) {
        //                     localStorage.setItem('zip_code', log_zipCode);
        //                 }
        //                 if (log_Utname != null) {
        //                     localStorage.setItem('utility_Name', log_Utname);
        //                 }
        //                 await findAssociatedDeals(recordId);

        if (storage.rawGet("userEmail") !== email) {
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
        }
        storage.rawSet("userEmail", email.toLowerCase())
        //                 document.querySelector('#page_0_returning_user_widget #userNotExist').innerHTML = '';
        const l_contactId = dataa.userValue.id
        storage.rawSet("contactId", l_contactId)
      }
    } catch (error) {
      //             enterZipcloseLoader();
      //             document.querySelector('#page_0_returning_user_widget #userNotExist').innerHTML = 'User does not exist';
      console.error("Error:", error)
    }
  }
  async function dealAssociateWithContact(contactId: any, dealId: any): Promise<void> {
__ea_trace("modules/self-serve/find-solar-popup.ts","dealAssociateWithContact",[contactId,dealId],["contactId","dealId"]);
    let emailll: any = storage.rawGet("logEmail")
    emailll = emailll.toLowerCase()
    void emailll
    let catchdata: any = ""
    try {
      const dataaa = {
        inputs: [
          {
            from: {
              id: contactId,
            },
            to: {
              id: dealId,
            },
          },
        ],
      }
      const response = await fetch(apiUrl("DealAssociateWithContact"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataaa),
      })
      catchdata = dataaa
      if (response.status === 200) {
        const dlowner = storage.rawGet("dealOwner")
        if (dlowner != null) {
          dealOwner = dlowner
        }
        await getDataFromContactRecordAndSaveLocal(dealId)
        await addedConfigIdWithSomeDataSignUp(dealOwner, dealId)
        clearDatabase()
        clearDatabaselmi()
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
  }
  async function SaveSessionDetailsOnLocalStorageSignUp(): Promise<void> {
__ea_trace("modules/self-serve/find-solar-popup.ts","SaveSessionDetailsOnLocalStorageSignUp",[],[]);
    const exampleUtilityId = storage.rawGet("utility_id")
    const hubDBEndpoint = hubdbRowsUrl("utilityAvailability", {
      utility_id__eq: String(exampleUtilityId),
    })
    const response = await fetch(hubDBEndpoint, { method: "GET" })
    const data = await response.json()
    const rows = data.objects
    if (rows.length >= 1) {
      storage.rawSet("Config ID", rows[0].id)
      rows.forEach((element: any) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[element],["element"]);
        if (exampleUtilityId === element.values["1"]) {
          storage.rawSet("SessionDetails", JSON.stringify(element.values))
          storage.rawSet("stateForLMIConfig", element.values["13"].name)
          storage.rawSet("UtilitySessionDetails", JSON.stringify(element.values))
          storage.rawSet("UtilityRate", element.values["78"])
          storage.rawSet("SubSizingFactor", element.values["79"])
          storage.rawSet("standardRate", element.values["80"])
          storage.rawSet("lmiNseRate", element.values["81"])
          storage.rawSet("standardRate", element.values["80"])
          storage.rawSet("lmiNseRate", element.values["81"])
          storage.rawSet("acSystemSize", element.values["82"])
          storage.rawSet("acKwh", element.values["84"])
        } else {
        }
      })
    }
  }
  async function addedConfigIdWithSomeDataSignUp(rep: any, dealId: any): Promise<void> {
__ea_trace("modules/self-serve/find-solar-popup.ts","addedConfigIdWithSomeDataSignUp",[rep,dealId],["rep","dealId"]);
    setTimeout(async () => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[],[]);
      if (rep === 0 || rep === "" || rep == null) {
        await SaveSessionDetailsOnLocalStorageSignUp()
        //         var email = localStorage.getItem("userEmail");
        let email: any = storage.rawGet("logEmail")
        email = email.toLowerCase()
        const SessionLocalStorage: any = JSON.parse(storage.rawGet("SessionDetails") as string)
        const SessionConfigID = storage.rawGet("Config ID")
        const utility_id = storage.rawGet("utility_id")
        let utility_Name = ""
        const FarmName = storage.rawGet("FarmName")
        const FarmID = storage.rawGet("FarmID")
        const UserDevice = storage.rawGet("User Device")
        const BrowserName = storage.rawGet("Browser Name")
        const opratingSystem = storage.rawGet("Operating System")
        let upd_attcode: any = storage.rawGet("attcode")
        let upd_repid: any = storage.rawGet("repid")
        let upd_referralUrl: any = storage.rawGet("referralUrl")
        if (upd_attcode == null) {
          upd_attcode = ""
          upd_repid = ""
          upd_referralUrl = first_visited_url
        }
        const BillOption = SessionLocalStorage["40"]
        let utility_ext_id_1 = ""
        let utility_ext_id_1_system = ""
        let utility_ext_id_2 = ""
        let utility_ext_id_2_system = ""
        let utility_ext_id_3 = ""
        let utility_ext_id_3_system = ""
        if (SessionLocalStorage["6"]) {
          utility_Name = SessionLocalStorage["6"]
        }
        if (SessionLocalStorage["7"]) {
          utility_ext_id_1 = SessionLocalStorage["7"]
        }
        if (SessionLocalStorage["8"].name) {
          utility_ext_id_1_system = SessionLocalStorage["8"].name
        }
        if (SessionLocalStorage["9"]) {
          utility_ext_id_2 = SessionLocalStorage["9"]
        }
        if (SessionLocalStorage["10"]) {
          utility_ext_id_2_system = SessionLocalStorage["10"].name
        }
        if (SessionLocalStorage["11"]) {
          utility_ext_id_3 = SessionLocalStorage["11"]
        }
        if (SessionLocalStorage["12"]) {
          utility_ext_id_3_system = SessionLocalStorage["12"].name
        }
        if (upd_attcode === "undefined") {
          upd_attcode = ""
        }
        if (upd_repid === "undefined") {
          upd_repid = ""
        }
        if (upd_referralUrl === "undefined") {
          upd_referralUrl = first_visited_url
        }
        let catchdata: any = ""
        try {
          const data = {
            properties: {
              deal_id: dealId,
              solar_farm_id: FarmID,
              solar_farm_name: FarmName,
              utility_name: utility_Name,
              utility_id: utility_id,
              session_config_id: SessionConfigID,
              bill_option: BillOption,
              ext_id_1: utility_ext_id_1,
              ext_id_1_system: utility_ext_id_1_system,
              ext_id_2: utility_ext_id_2,
              ext_id_2_system: utility_ext_id_2_system,
              ext_id_3: utility_ext_id_3,
              ext_id_3_system: utility_ext_id_3_system,
              user_agent: BrowserName,
              user_device: UserDevice,
              user_agent___operating_system: opratingSystem,
              attribution_code: upd_attcode,
              attribution_rep: upd_repid,
              referral_url: upd_referralUrl,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          ;(window as any).enterZipcloseLoader()
          storage.rawSet("userEmail", email.toLowerCase())
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
          if (storage.rawGet("FarmStateAbbreviation") === "IL") {
            window.location.href = "/il-usage" // redirect to login page
          } else {
            window.location.href = "/my-info?mltenlmt" // redirect to login page
          }
          const result = await response.json()
        } catch (error) {
          console.error("Error:", error)
        }
        return true
      } else {
        await SaveSessionDetailsOnLocalStorageSignUp()
        //         var email = localStorage.getItem("userEmail");
        let email: any = storage.rawGet("logEmail")
        email = email.toLowerCase()
        const SessionLocalStorage: any = JSON.parse(storage.rawGet("SessionDetails") as string)
        const SessionConfigID = storage.rawGet("Config ID")
        const utility_id = storage.rawGet("utility_id")
        let utility_Name = ""
        const FarmName = storage.rawGet("FarmName")
        const FarmID = storage.rawGet("FarmID")
        const UserDevice = storage.rawGet("User Device")
        const BrowserName = storage.rawGet("Browser Name")
        const opratingSystem = storage.rawGet("Operating System")
        let upd_attcode: any = storage.rawGet("attcode")
        let upd_repid: any = storage.rawGet("repid")
        let upd_referralUrl: any = storage.rawGet("referralUrl")
        if (upd_attcode == null) {
          upd_attcode = ""
          upd_repid = ""
          upd_referralUrl = first_visited_url
        } else {
          upd_referralUrl = first_visited_url
        }
        const BillOption = SessionLocalStorage["40"]
        let utility_ext_id_1 = ""
        let utility_ext_id_1_system = ""
        let utility_ext_id_2 = ""
        let utility_ext_id_2_system = ""
        let utility_ext_id_3 = ""
        let utility_ext_id_3_system = ""
        if (SessionLocalStorage["6"]) {
          utility_Name = SessionLocalStorage["6"]
        }
        if (SessionLocalStorage["7"]) {
          utility_ext_id_1 = SessionLocalStorage["7"]
        }
        if (SessionLocalStorage["8"].name) {
          utility_ext_id_1_system = SessionLocalStorage["8"].name
        }
        if (SessionLocalStorage["9"]) {
          utility_ext_id_2 = SessionLocalStorage["9"]
        }
        if (SessionLocalStorage["10"]) {
          utility_ext_id_2_system = SessionLocalStorage["10"].name
        }
        if (SessionLocalStorage["11"]) {
          utility_ext_id_3 = SessionLocalStorage["11"]
        }
        if (SessionLocalStorage["12"]) {
          utility_ext_id_3_system = SessionLocalStorage["12"].name
        }
        if (upd_attcode === "undefined") {
          upd_attcode = ""
        }
        if (upd_repid === "undefined") {
          upd_repid = ""
        }
        if (upd_referralUrl === "undefined") {
          upd_referralUrl = first_visited_url
        } else {
          upd_referralUrl = first_visited_url
        }
        let catchdata: any = ""
        try {
          const data = {
            properties: {
              deal_id: dealId,
              solar_farm_id: FarmID,
              solar_farm_name: FarmName,
              utility_name: utility_Name,
              utility_id: utility_id,
              session_config_id: SessionConfigID,
              bill_option: BillOption,
              ext_id_1: utility_ext_id_1,
              ext_id_1_system: utility_ext_id_1_system,
              ext_id_2: utility_ext_id_2,
              ext_id_2_system: utility_ext_id_2_system,
              ext_id_3: utility_ext_id_3,
              ext_id_3_system: utility_ext_id_3_system,
              user_agent: BrowserName,
              user_device: UserDevice,
              user_agent___operating_system: opratingSystem,
              hubspot_owner_id: rep,
              attribution_code: upd_attcode,
              attribution_rep: upd_repid,
              referral_url: upd_referralUrl,
            },
          }
          const response = await fetch(apiUrl("UpdateDealRecord"), {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
          catchdata = data
          ;(window as any).enterZipcloseLoader()
          storage.rawSet("userEmail", email.toLowerCase())
          if (storage.rawGet("skipUsage") !== null) {
            storage.rawRemove("skipUsage")
          }
          if (storage.rawGet("FarmStateAbbreviation") === "IL") {
            window.location.href = "/il-usage" // redirect to login page
          } else {
            window.location.href = "/my-info?mltenlmt" // redirect to login page
          }
          const result = await response.json()
        } catch (error) {
          console.error("Error:", error)
        }
        return true
      }
    }, 4000)
  }
  /* create deal record */

  /* Getting Address and Utility Name from Farm Table based on lowest priority */
  const limitt = 1000
  let offsett = 0
  let allFarmRowss: any[] = []
  function checkUtilityIdInFarmTable(U_Id: string): any {
__ea_trace("modules/self-serve/find-solar-popup.ts","checkUtilityIdInFarmTable",[U_Id],["U_Id"]);
    //live farm table id 15223639
    const hubDBEndpoint = hubdbRowsUrl("utilityFarm", {
      limit: limitt,
      offset: offsett,
    })
    fetch(hubDBEndpoint, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[data],["data"]);
        const matchingRowss = data.objects.filter((row: any) => row.values[10] === U_Id)
        const rowss = data.objects
        allFarmRowss = allFarmRowss.concat(matchingRowss)
        if (rowss.length === limitt) {
          // There might be more rows, fetch the next page
          offsett += limitt
          return checkUtilityIdInFarmTable(U_Id)
        }
        const priorityArray: any[] = []
        let inc = 0
        for (let i = 0; i <= allFarmRowss.length; i++) {
          const currentobj = allFarmRowss[i]
          const FarmStateAbbreviation = currentobj.values[5]
          if (
            FarmStateAbbreviation === "ME" ||
            FarmStateAbbreviation === "CO" ||
            FarmStateAbbreviation === "DE" ||
            FarmStateAbbreviation === "NY" ||
            FarmStateAbbreviation === "MD" ||
            FarmStateAbbreviation === "IL"
          ) {
            ++inc
            const FarmZip = currentobj.values[6]
            const FarmName = currentobj.values[7]
            const FarmID = currentobj.values[1]
            const priority = currentobj.values[12]
            const FarmDisplayName = currentobj.values[2]
            const FarmStreetAddress1 = currentobj.values[3]
            const FarmStreetAddress2 = currentobj.values[13]
            const FarmCity = currentobj.values[4]
            const FarmEmail = currentobj.values[28]
            const FarmPhoneNumber = currentobj.values[23]
            const FarmProjectDescription = currentobj.values[22]
            const FarmLlc = currentobj.values[21]
            const FarmLMIDiscount = currentobj.values[19]
            const FarmOpenDiscount = currentobj.values[20]
            const FarmCounty = currentobj.values[35]
            const myObject = {
              FarmZip: FarmZip,
              FarmName: FarmName,
              FarmID: FarmID,
              priority: priority,
              FarmDisplayName: FarmDisplayName,
              FarmStreetAddress1: FarmStreetAddress1,
              FarmStreetAddress2: FarmStreetAddress2,
              FarmCity: FarmCity,
              FarmEmail: FarmEmail,
              FarmStateAbbreviation: FarmStateAbbreviation,
              FarmPhoneNumber: FarmPhoneNumber,
              FarmProjectDescription: FarmProjectDescription,
              FarmLlc: FarmLlc,
              FarmLMIDiscount: FarmLMIDiscount,
              FarmOpenDiscount: FarmOpenDiscount,
              FarmCounty: FarmCounty,
            }
            if (currentobj.values[9] === 1) {
              priorityArray.push(myObject)
            }
          }
          if (i === allFarmRowss.length - 1) {
            if (priorityArray.length > 0) {
              //                         var ezzz = document.getElementById('Page_0_Enter_Zip_widget');
              //                         var pnfff = document.getElementById('Page_0_Project_not_Found_widget');
              //                         var pfff = document.getElementById('Page_0_Project_Found_widget');
              //                         ezzz.style.display = 'none';
              //                         pnfff.style.display = 'none';
              //                         pfff.style.display = 'block';
              // Now correspondingObject contains the object with the lowest priority
              const minPriorityObject = priorityArray.reduce(
                (min, obj) => (obj.priority < min.priority ? obj : min),
                priorityArray[0],
              )

              storage.rawSet("FarmStreetAddress1", minPriorityObject.FarmStreetAddress1)
              storage.rawSet("FarmStreetAddress2", minPriorityObject.FarmStreetAddress2)
              storage.rawSet("FarmCity", minPriorityObject.FarmCity)
              storage.rawSet("FarmStateAbbreviation", minPriorityObject.FarmStateAbbreviation)
              storage.rawSet("FarmName", minPriorityObject.FarmName)
              storage.rawSet("FarmID", minPriorityObject.FarmID)
              storage.rawSet("FarmPhoneNumber", minPriorityObject.FarmPhoneNumber)
              storage.rawSet("FarmEmail", minPriorityObject.FarmEmail)
              storage.rawSet("FarmProjectDescription", minPriorityObject.FarmProjectDescription)
              storage.rawSet("FarmLlc", minPriorityObject.FarmLlc)
              storage.rawSet("FarmDisplayName", minPriorityObject.FarmDisplayName)
              storage.rawSet("FarmLMIDiscount", minPriorityObject.FarmLMIDiscount)
              storage.rawSet("FarmOpenDiscount", minPriorityObject.FarmOpenDiscount)
              storage.rawSet("FarmCounty", minPriorityObject.FarmCounty)
              createDealRecord()
              break
            } else if (
              FarmStateAbbreviation === "MN" /*|| FarmStateAbbreviation == "NY" || FarmStateAbbreviation == "MD"*/
            ) {
              window.location.href = "https://enroll.nautilussolar.com/"
              break
            } else {
              alert("Project not found for this Zip Code")
              window.location.href = "/dashboard"
              //                         var ezz = document.getElementById('Page_0_Enter_Zip_widget');
              //                         var pnff = document.getElementById('Page_0_Project_not_Found_widget');
              //                         var pff = document.getElementById('Page_0_Project_Found_widget');
              //                         ezz.style.display = 'none';
              //                         pff.style.display = 'none';
              //                         pnff.style.display = 'block';
              break
            }
          }
        }
      })
      .catch((error) => {
__ea_trace("modules/self-serve/find-solar-popup.ts","(anon)",[error],["error"]);
        console.error("Error fetching data from HubDB:", error)
      })
  }
  /* Getting Address and Utility Name from Farm Table based on lowest priority */

  // ─── wire the (formerly inline) handlers ──────────────────────────────────────
  const zipCodeInput = root.querySelector("#zipCode") as HTMLInputElement
  zipCodeInput?.addEventListener("input", () => validateNumericInput(zipCodeInput))
  root.querySelector(".zipCodeButton button")?.addEventListener("click", () => findSolar())
}
